import React from 'react'
import BottomNav from './BottomNav'

const Travel = () => {
  return (
    <>
        <BottomNav />
    </>
  )
}

export default Travel